import React, { Component } from 'react'
import { Flex, Box } from 'reflexbox'
import { withRouter } from 'react-router'
import { Switch, CardContent, Typography, FormControlLabel, Collapse } from '@material-ui/core'
import * as yup from 'yup'
import set from 'set-value'

import {
  BounceAnimatedContainer, CentredContainer,
  HealtheraButton, CardContainer, Header, CardHeader, SubHeader,
  GreenCheckbox, OrganisationSettingsToggleLabel,
} from '../../healtheraComponents'
import OneIcon from '../../resources/card_1.png'
import TwoIcon from '../../resources/card_2.png'
import ThreeIcon from '../../resources/card_3.png'
import { validated, totalExceeded } from '../../helpers'
import DynamicForm from '../DynamicForm/DynamicForm'
import DealSummary from '../DealSummary/DealSummary'
import { Schema } from './InputSchema'
import OrganisationPlanSelect from '../Shared/OrganisationPlanSelect'

class CreateOrganisation extends Component {

  state = { orgDetails: { vat: true, discount: 0, plan: 'starter' }, showCard: { one: false, two: false }, validationArray: [] }

  componentDidMount() {
    this.props.getWhiteLabelApps();
  }

  componentWillUnmount() {
    Object.keys(Schema).map(key => Object.keys(Schema[key]).map(k => Schema[key][k].value ? Schema[key][k].value = '' : ''))
  }

  onChange({ field, value, validation }) {
    let { orgDetails, validationArray } = this.state;

    if (field === 'white_label_app_id') {
      const { whiteLabelApps } = this.props;
      const { _id: wlId } = whiteLabelApps.find(i => i.name === value) || {};
      value = wlId || null;
    } else {
      set(validationArray, field, validation);
    }

    set(orgDetails, field, value);
    this.setState({ orgDetails, validationArray });
  }

  handleChange(key, e) {
    const { orgDetails } = this.state
    this.setState({ orgDetails: { ...orgDetails, ...orgDetails.vat, [key]: e.target.checked } })
  }

  proceed(page) {
    const { showCard } = this.state
    showCard[page] = !showCard[page]
    this.setState({ showCard })
  }

  hasContract(orgDetails) {
    let res = false
    const { showCard: { one } } = this.state
    const { currentContract, address, primaryUser } = orgDetails

    if (orgDetails.currentContract && one) {
      const { slots, startDate, unitPrice, count } = currentContract
      res = (slots && startDate && unitPrice && count)
    }
    if (primaryUser && address && orgDetails.name && !one) {
      const { postcode, name } = address
      const { email, firstName, lastName, position, telephone } = primaryUser
      res = (postcode && name && orgDetails.name && email && firstName && lastName && position && telephone)
    }
    return res
  }

  needsClinicId(orgDetails) {
    if (orgDetails.type !== 'prescriber') return false;
    return !orgDetails.clinic_id;
  }

  // Create Account
  async handleSubmit() {
    const { orgDetails } = this.state;
    const { commissions, ...otherParams } = orgDetails || {};

    const payload = {
      ...otherParams,
      commissions: {
        defaultRate: commissions
      }
    };

    await this.props.createOrganisation(payload).then(() => {
      // When tabs Active/Deactivated are used again
      // const { mainTabValue } = this.props
      this.props.history.push(`${process.env.PUBLIC_URL}/`);
      this.props.getOrganisations(null, 0, 'active');
    });
  }

  render() {
    const { whiteLabelApps } = this.props;
    const adminDetailsSchema = {
      ...Schema.adminDetails,
      'White Label': {
        type: 'editableSelect',
        values: ['none', ...whiteLabelApps.map(i => i.name)],
        field: 'white_label_app_id',
      },
    };
    const { validationArray, showCard, orgDetails, orgDetails: { vat, currentContract, currentContract: { count, email, startDate } = {} } = {} } = this.state
    const buttonOneDisabled = !validated(validationArray)
      || Object.keys(orgDetails).length <= 5
      || showCard.one
      || !this.hasContract.bind(this)(orgDetails)
      || this.needsClinicId(orgDetails)
    const buttonTwoDisabled = !validated(validationArray)
      || showCard.two
      || !this.hasContract.bind(this)(orgDetails)
    const submit = !validated(validationArray) || totalExceeded(orgDetails) || (currentContract && count === '') || (currentContract && email === '') || (currentContract && startDate === '')

    return (
      <BounceAnimatedContainer>
        <Header title='Create a New Account' />
        <CardContainer>
          <CardContent id='business_details'>
            <CardHeader icon={OneIcon} title='Business Details' />
            <Flex>
              <Box w={548}>
                <DynamicForm onChange={this.onChange.bind(this)} fields={Schema.businessName} />
                <SubHeader title='Business Address' />
                <DynamicForm onChange={this.onChange.bind(this)} fields={Schema.businessAddress} />
              </Box>
              <Box w={548}>
                <DynamicForm onChange={this.onChange.bind(this)} fields={Schema.companyNumber} />
                <SubHeader title='Administrator Details' />
                <DynamicForm onChange={this.onChange.bind(this)} fields={adminDetailsSchema} />
                <Box style={{ marginTop: '16px' }}>
                  <Typography>Organisation Type</Typography>
                  <OrganisationSettingsToggleLabel>Clinic</OrganisationSettingsToggleLabel>
                  <Switch
                    checked={orgDetails?.type === 'prescriber'}
                    onChange={(e) => this.onChange({
                      field: 'type',
                      value: e.target.checked ? 'prescriber' : null,
                      validation: true,
                    })}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Box>
                <Collapse in={orgDetails?.type === 'prescriber'}>
                  <DynamicForm onChange={this.onChange.bind(this)} fields={{
                    'Clinic ID': {
                      value: orgDetails?.clinic_id || '',
                      field: 'clinic_id',
                      validation: yup.string().required(),
                    }
                  }} />
                </Collapse>
              </Box>
            </Flex>
            <br />
            <HealtheraButton background={buttonOneDisabled ? '#bbbbbb' : '#2f9d6d'} disabled={buttonOneDisabled} target="_self" href="#plan_details" onClick={() => this.proceed.bind(this)('one')} width={`205px`} height={`45px`} margin={`0% 39% 2%`}> Proceed </HealtheraButton>
          </CardContent>
        </CardContainer>

        <CardContainer opacity={showCard.one ? '1' : '0.35'}>
          <CardContent id="plan_details">
            <CardHeader icon={TwoIcon} title='Plan Details' />
            <Box >
              <OrganisationPlanSelect
                plan={orgDetails.plan}
                disabled={!showCard.one}
                onChange={plan => this.onChange({ field: 'plan', value: plan, validation: true })}
              />
              <Flex>
                <Box w={548}><DynamicForm disabled={!showCard.one} onChange={this.onChange.bind(this)} fields={Schema.customPrice} /></Box>
              </Flex>
              <Flex>
                <Box w={548}><DynamicForm disabled={!showCard.one} onChange={this.onChange.bind(this)} fields={Schema.discount} /></Box>
              </Flex>

              <SubHeader title='Contract Terms' />
              <Flex>
                <Box><DynamicForm disabled={!showCard.one} onChange={this.onChange.bind(this)} fields={Schema.contractTermsLeft} /></Box>
                <Box><DynamicForm disabled={!showCard.one} onChange={this.onChange.bind(this)} fields={Schema.contractTermsRight} /></Box>
              </Flex>
              <Flex pt={3}>
                <FormControlLabel
                  control={
                    <GreenCheckbox
                      checked={vat}
                      onChange={this.handleChange.bind(this, 'vat')}
                      value='vat'
                    />}
                  label='VAT Applicable'
                />
              </Flex>
            </Box>
            <HealtheraButton background={buttonTwoDisabled ? '#bbbbbb' : '#2f9d6d'} disabled={buttonTwoDisabled} target="_self" href="#summary" onClick={() => this.proceed.bind(this)('two')} width={`205px`} height={`45px`} margin={`0% 39% 2%`}> Proceed </HealtheraButton>
          </CardContent>
        </CardContainer>

        <CardContainer opacity={showCard.one && showCard.two ? '1' : '0'}>
          <CardContent id="summary">
            <CardHeader icon={ThreeIcon} title='Summary' />
            <DealSummary deal={orgDetails} header={`Deal`} />
            <CentredContainer padding={`40px 0 20px 0`}>
              <HealtheraButton background={submit ? '#bbbbbb' : '#2f9d6d'} disabled={submit} onClick={this.handleSubmit.bind(this)} >
                Create New Account
              </HealtheraButton>
            </CentredContainer>
            <CentredContainer>
              <p>Creating a new account will initiate a sales deal request to the e-mail address above with a link to terms and conditions and adding payment details</p>
            </CentredContainer>
          </CardContent>
        </CardContainer>
      </BounceAnimatedContainer>
    )
  }
}

export default withRouter(CreateOrganisation)
